import React from 'react';

import './styles.css';

const Notice = () => (
  <div className="notice">
    By clicking “YES, UPGRADE ME”, you authorize us to charge $179.99 USD,
    minus any applicable discount, to the payment method on file for an annual subscription.
    Sales tax will also be charged, where applicable.
    Free shipping on boxes shipped in contiguous US.
    Shipping charges of $8 USD per box applies for shipping to Canada, Hawaii, Alaska and Puerto Rico.
    Shipping charges of $10 USD per box applies for shipping to the United Kingdom.
    Foreign exchange or transaction fees may apply for non-US customers.
    Subscription will auto-renew after 4 boxes. Cancel anytime.
    <br />
    <br />
    *Savings based on comparison to Seasonal Subscription price for four boxes.
  </div>
);

export default Notice;
